export function getBaseUrl() {
    if (
        typeof window !== "undefined" &&
        window.location.hostname === "localhost"
    ) {
        return "http://localhost:3000";
    }
    return "https://oakmate.app";
}
